
export interface HealthLog {
  id: string;
  user_id?: string;
  date: string;
  weight: number;
  height: number;
  bmi: number;
  systolic: number;
  diastolic: number;
  triglyceride: number;
  cholesterol: number;
  hdl: number;
  ldl: number;
  fbs?: number;
  ast?: number;
  alt?: number;
}

export interface UserProfile {
  id: string;
  full_name: string;
  birth_date: string;
  gender: 'ชาย' | 'หญิง' | 'อื่นๆ';
  height: number;
}

export interface PredictionResult {
  futureWeight: number;
  futureSystolic: number;
  futureDiastolic: number;
  futureCholesterol: number;
  futureTriglyceride: number;
  futureHDL: number;
  futureLDL: number;
  aiAdvice: string;
  riskLevel: 'ต่ำ' | 'ปานกลาง' | 'สูง';
}

export interface MedicationReminder {
  id: string;
  user_id?: string;
  name: string;
  time: string;
  dosage?: string;
  days: string[];
  active: boolean;
}

export interface Appointment {
  id: string;
  user_id?: string;
  date: string;
  time: string;
  clinic: string;
  notes: string;
}

export enum NavigationTab {
  DASHBOARD = 'DASHBOARD',
  LOGS = 'LOGS',
  SIMULATOR = 'SIMULATOR',
  ALERTS = 'ALERTS',
  PROFILE = 'PROFILE'
}
